


import ReactDOM from 'react-dom';
import React from 'react';
import './style.css';
import App from './App';

window.addEventListener('load', () => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
